import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=bbb310c4&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=ts"
export * from "./orderList.vue?vue&type=script&lang=ts"
import style0 from "./orderList.vue?vue&type=style&index=0&id=bbb310c4&prod&lang=scss&scoped=true"
import style1 from "./orderList.vue?vue&type=style&index=1&id=bbb310c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb310c4",
  null
  
)

export default component.exports